import clsx from 'clsx'

import { ProgressBarProps } from './ProgressBar.types'

export const ProgressBar = (props: ProgressBarProps) => {
  const { className, value } = props

  const classNames = clsx('ProgressBar', className)

  return (
    <div className={classNames}>
      <div
        aria-label={`${value}%`}
        aria-valuemax={100}
        aria-valuemin={0}
        aria-valuenow={value}
        className="ProgressBar-value"
        role="progressbar"
        style={{ width: `${value}%` }}
      />
    </div>
  )
}
